import type { ProfileRecheckResponse } from '@discovr/features';
import { RowRecheckButton } from '../RowRecheckButton';
import { profileRecheckLabel, type CreatorLookup } from './creatorLookupStatus';
import { useIsRechecking, useProfileRecheckStore } from './profileRecheckStore';

type ProfileRecheckButtonProps = {
  campaignId: string;
  entryId: string;
  handle: string | undefined;
  lookup: CreatorLookup;
  recheck: (entryId: string) => Promise<ProfileRecheckResponse>;
};

/** Creators-tab ⟳ for one row. Keeps spinning until a newer fetch lands on
 *  the row, for at most the server cooldown the 202 reported. */
export function ProfileRecheckButton({ campaignId, entryId, handle, lookup, recheck }: ProfileRecheckButtonProps) {
  const pending = useIsRechecking(campaignId, entryId, 'profile', lookup);
  const markRechecking = useProfileRecheckStore((state) => state.markRechecking);

  const handleRun = async () => {
    const res = await recheck(entryId);
    markRechecking(campaignId, entryId, 'profile', lookup, res.retry_after_seconds);
  };

  return <RowRecheckButton label={profileRecheckLabel(handle)} pending={pending} onRun={handleRun} />;
}
